import { useLocation } from 'react-router-dom';
const useIsSurveyTemplatesPage = (): boolean => {
  const { pathname } = useLocation();
  return pathname === '/administrator/survey-templates';
};

export default useIsSurveyTemplatesPage;
